import * as yup from 'yup';
import { SelectCollectionDeliveryPageFormData } from './SelectCollectionDeliveryPageFormData';

export const SelectCollectionDeliveryPageFormSchema: yup.SchemaOf<SelectCollectionDeliveryPageFormData> = yup.object({
  collectionRequested: yup.boolean().required(),
  dropOffRequested: yup.boolean().required(),
});
